import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const Copy = ({
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.SECONDARY.DARK_900,
  className = 'w-4 h-4',
  styles
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      className={styles || className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'>
      <rect
        x='9'
        y='9'
        width='13'
        height='13'
        rx='2'
        ry='2'
        stroke={fillColor}
        strokeWidth='2'
        fill='none'
      />
      <path
        d='M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
    </svg>
  );
};

export default Copy;
